document.addEventListener('DOMContentLoaded', function() {
    // Facetフィルタードロワーの表示/非表示
    var openButton = document.getElementById('openFacetedFilterDrawer');
    var closeButton = document.getElementById('closeFacetedFilterDrawer');
    var drawer = document.querySelector('.faceted-filter-drawer-wrapper');

    openButton.addEventListener('click', function() {
        drawer.style.display = 'block';
        drawer.style.bottom = '0';
    });

    closeButton.addEventListener('click', function() {
        drawer.style.display = 'fixed'; // ドロワーを非表示
        drawer.style.bottom = '-100%';
    });

    // SP時Facetフィルターボタンの表示/非表示
    const stickyButton = document.querySelector('.faceted-filter-sticky-button');
    const footerContainer = document.querySelector('.footer__container');

    if (stickyButton && footerContainer) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    stickyButton.style.bottom = '-100%'; // フッターが見えたらボタンを非表示
                } else {
                    stickyButton.style.bottom = '.5rem'; // フッターが見えなくなったらボタンを表示
                }
            });
        });
        observer.observe(footerContainer);
    }
});
